const devConfig = require('./config.dev.json')
const prodConfig = require('./config.prod.json')

const deployEnv = process.env.REACT_APP_DEPLOY_ENV
const nodeEnv = process.env.NODE_ENV

console.log(`Deploy Env: ${deployEnv}, Node env: ${nodeEnv}`)

const env = deployEnv || nodeEnv

export default env === 'prod' || env === 'production' ? prodConfig : devConfig
